import './App.css';
import { useEffect } from 'react';

function App() {
  const redirectVisit = () => {
    window.location.replace('https://www.arcomputacion.com.ar/')
  }

  useEffect(() => {
    redirectVisit();
  })

  return (
    <div className="App">
    </div>
  );
}

export default App;
